import Swiper, { Navigation, Pagination, Mousewheel, EffectCoverflow, Autoplay } from 'swiper';
Swiper.use([ Navigation, Pagination, Mousewheel, EffectCoverflow, Autoplay]);

export function heroSliderBuilder() {
    let sequences = [[]]
    let currentIndex = 0

    $('.hero').each((index, hero) => {
        if(!sequences[currentIndex].length) sequences[currentIndex].push(hero)
        let nextHero = $(hero).next('.hero')
        if(nextHero.length){
            sequences[currentIndex].push(nextHero[0])
        }else{
            sequences.push([])
            currentIndex++
        }
    })

    sequences.forEach(function(sequence){
        if(sequence.length > 1){
            let sliderContent = sequence.map((item, index) => {
                $('.hero__observer', item).remove() 
                $(item).wrap('<div class="swiper-slide"></div>')
                return $(item).parent().get(0)
            })
            $(sliderContent).wrapAll('<section class="swiper-container swiper--heroes"><div class="swiper-wrapper"></div></section>')
            $(sliderContent).closest('.swiper--heroes').append('<div class="swiper__observer"></div>')
            $(sliderContent).closest('.swiper--heroes').append('<div class="swiper-pagination swiper-pagination--thumbnails wrap skeleton"></div>')
        }
    })

    let sliders = document.querySelectorAll('.swiper--heroes')
    sliders.forEach(function(slider){
        let menu = []
        let pagination = $('.swiper-pagination', slider).length && $('.swiper-pagination', slider)[0]
        $('.hero', slider).each(function(){
            menu.push({ 'title': $(this).attr('data-title'), 'image': $(this).attr('data-image') })
          })
        const swiper = new Swiper(slider, {
                grabCursor: true,
                mousewheel: {
                    invert: false,
                    forceToAxis: true,
                },
                autoplay: {
                    delay: 10000,
                },
                on: {
                    autoplayStop: function() {
                        $(slider).addClass('swiper--stopped')
                    },
                    autoplayStart: function() {
                        $(slider).removeClass('swiper--stopped')
                    }
                },
                pagination: {
                    el: pagination,
                    clickable: true,
                    type: 'custom',
                    renderCustom: function(swiper, current, total) {
                        let text = "";
                        let loader = "<div class='thumbnail__circle'><div class='half'><div class='halfcircle in'></div></div><div class='halfcircle out'></div></div>"
                        if(typeof swiper.previousIndex === 'undefined'){
                            for (let i = 0; i < total; i++) {
                                let classes = "swiper-pagination-bullet swiper-pagination-thumbnail thumbnail";
                                if(current == i+1) classes += ' swiper-pagination-thumbnail-active'
                                text += '<div class="'+ classes + '">'+ '<div class="thumbnail__image">'+ loader +'<img src="'+ (menu[i]['image'] ? menu[i]['image'] : '') + '"/></div><div class="thumbnail__title">' + (menu[i]['title'] ? menu[i]['title'] : '') + '</div></div>';
                            }
                            return text;
                        } else {
                            $(pagination).children('.swiper-pagination-thumbnail').each(function(i){
                                $(this).removeClass('swiper-pagination-thumbnail-active')
                                $(this).removeClass('swiper-pagination-thumbnail-selected')
                                if(current == i+1) $(this).addClass('swiper-pagination-thumbnail-active')
                            })
                        }
                    }
                }
            })
    })
}
